// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products_scrollable__Z-bmY {
  overflow-x: scroll;
  display: flex;
  flex-direction: row;
  background-color: #fff;
}

.products_scrollableItem__FasXJ {
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
}

.products_selected__Js7AZ {
  background-color: var(--global-main-color);
  color: #fff;
}

.products_productContainer__Ut5FI {
  background-color: #ffffff;
  margin-right: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px #0000001a;
  max-width: 250px;
  text-align: left;
}

.products_plus__1\\+u-o {
  color: var(--global-main-color);
  font-size: 1.5rem;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.products_counter__Xw085 {
  display: flex;
  padding: 0.4rem 0.7rem;
  align-items: center;
  background-color: var(--global-main-color);
  border-radius: 30px;
}

.products_addToCart__KpJox {
  background-color: #ffffff;
  color: var(--global-main-color);
  display: flex;
  align-items: center;
  font-weight: 600;
  padding: 0.4rem 0.7rem;
  border-radius: 30px;
  border: 1px solid #ccc;
  width: 110px;
  justify-content: center;
  cursor: pointer;
}

.products_addToCart__KpJox:hover {
  background-color: var(--global-main-color);
  color: #ffffff;
  border-color: transparent;
}

.products_productListContainer__EodFf {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around; /* You can adjust this as needed */
  margin: 0 auto; /* Center the container on the page */
  max-width: 1200px; /* Adjust the max width as needed for responsiveness */
  padding: 20px;
}

/* If you want to add spacing between product cards */
.products_productListContainer__EodFf > div {
  margin: 10px;
}

.products_sidebar__nqB1f {
  width: 240px;
  min-width: 240px;
  background-color: #fff;
  position: fixed;
  height: 100%;
}

.products_responsiveContainer__IVYEI {
  margin-right: 1.5rem;
  margin-left: 1.5rem;
}

.products_responsiveSearch__hfprH {
  flex-basis: 40%;
}

.products_responsiveFlex__HltmR {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.products_responsiveFlexWarehouse__vwPPA {
  flex-direction: row;
  /* justify-content: center; */
  display: flex;
  flex-wrap: wrap;
}

.products_responsiveProduct__FEskV {
  flex-basis: 33.33%;
  /* flex-basis: 33.33%; */
}

.products_responsiveProductWarehouse__BGy9S {
  /* flex-basis: 16.666%; */
  flex-basis: 16.666%;
  /* background-color: red; */
  width: 33.33%;
}

.products_responsiveModalImage__7zyYf {
  flex-basis: 40%;
}

.products_responsiveModalContainer__Xtu6d {
  flex-basis: 59%;
}

.products_responsiveModal__ZaRmd {
  -webkit-user-select: none;
          user-select: none;
  padding: 16px;
  display: flex;
  justify-content: space-between;
}

.products_hideMobile__VKxoq {
  display: block;
}

.products_showMobile__BchuZ {
  display: none;
}

@media (max-width: 650px) {
  .products_hideMobile__VKxoq {
    display: none;
  }

  .products_showMobile__BchuZ {
    display: block;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
  }

  .products_responsiveModalImage__7zyYf {
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }

  .products_responsiveModalImage__7zyYf > img {
    height: 250px;
    width: auto;
  }

  .products_responsiveModalContainer__Xtu6d {
    flex-basis: 100%;
  }

  .products_responsiveModal__ZaRmd {
    padding: 16px;
    display: block;
  }

  .products_responsiveSearch__hfprH {
    flex-basis: 80%;
  }

  .products_responsiveContainer__IVYEI {
    margin-right: 0.4rem;
    margin-left: 0.4rem;
  }

  .products_responsiveFlexWarehouse__vwPPA {
    flex-direction: row;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    /* background-color: yellow; */
  }

  .products_responsiveFlex__HltmR {
    flex-direction: column;
    justify-content: center;
    display: block !important;
  }

  .products_responsiveProductWarehouse__BGy9S {
    flex-basis: 33.33%;
  }

  .products_responsiveProduct__FEskV {
    flex-basis: 100%;
  }
}

.products_stickyCategoryBar__VZFHb {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  background-color: #fff; /* Adjust the background color as needed */
  z-index: 1000; /* Adjust the z-index to make sure it appears above other elements */
}
`, "",{"version":3,"sources":["webpack://./src/shop/products/products.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B,EAAE,kCAAkC;EACjE,cAAc,EAAE,qCAAqC;EACrD,iBAAiB,EAAE,sDAAsD;EACzE,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB,EAAE,0CAA0C;EAClE,aAAa,EAAE,oEAAoE;AACrF","sourcesContent":[".scrollable {\n  overflow-x: scroll;\n  display: flex;\n  flex-direction: row;\n  background-color: #fff;\n}\n\n.scrollableItem {\n  font-weight: 600;\n  cursor: pointer;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.selected {\n  background-color: var(--global-main-color);\n  color: #fff;\n}\n\n.productContainer {\n  background-color: #ffffff;\n  margin-right: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px #0000001a;\n  max-width: 250px;\n  text-align: left;\n}\n\n.plus {\n  color: var(--global-main-color);\n  font-size: 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n  cursor: pointer;\n}\n\n.counter {\n  display: flex;\n  padding: 0.4rem 0.7rem;\n  align-items: center;\n  background-color: var(--global-main-color);\n  border-radius: 30px;\n}\n\n.addToCart {\n  background-color: #ffffff;\n  color: var(--global-main-color);\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  padding: 0.4rem 0.7rem;\n  border-radius: 30px;\n  border: 1px solid #ccc;\n  width: 110px;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.addToCart:hover {\n  background-color: var(--global-main-color);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.productListContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around; /* You can adjust this as needed */\n  margin: 0 auto; /* Center the container on the page */\n  max-width: 1200px; /* Adjust the max width as needed for responsiveness */\n  padding: 20px;\n}\n\n/* If you want to add spacing between product cards */\n.productListContainer > div {\n  margin: 10px;\n}\n\n.sidebar {\n  width: 240px;\n  min-width: 240px;\n  background-color: #fff;\n  position: fixed;\n  height: 100%;\n}\n\n.responsiveContainer {\n  margin-right: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.responsiveSearch {\n  flex-basis: 40%;\n}\n\n.responsiveFlex {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.responsiveFlexWarehouse {\n  flex-direction: row;\n  /* justify-content: center; */\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.responsiveProduct {\n  flex-basis: 33.33%;\n  /* flex-basis: 33.33%; */\n}\n\n.responsiveProductWarehouse {\n  /* flex-basis: 16.666%; */\n  flex-basis: 16.666%;\n  /* background-color: red; */\n  width: 33.33%;\n}\n\n.responsiveModalImage {\n  flex-basis: 40%;\n}\n\n.responsiveModalContainer {\n  flex-basis: 59%;\n}\n\n.responsiveModal {\n  user-select: none;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.hideMobile {\n  display: block;\n}\n\n.showMobile {\n  display: none;\n}\n\n@media (max-width: 650px) {\n  .hideMobile {\n    display: none;\n  }\n\n  .showMobile {\n    display: block;\n    position: sticky;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    display: flex;\n    justify-content: flex-end;\n    padding: 0.5rem;\n  }\n\n  .responsiveModalImage {\n    flex-basis: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .responsiveModalImage > img {\n    height: 250px;\n    width: auto;\n  }\n\n  .responsiveModalContainer {\n    flex-basis: 100%;\n  }\n\n  .responsiveModal {\n    padding: 16px;\n    display: block;\n  }\n\n  .responsiveSearch {\n    flex-basis: 80%;\n  }\n\n  .responsiveContainer {\n    margin-right: 0.4rem;\n    margin-left: 0.4rem;\n  }\n\n  .responsiveFlexWarehouse {\n    flex-direction: row;\n    justify-content: center;\n    display: flex;\n    flex-wrap: wrap;\n    /* background-color: yellow; */\n  }\n\n  .responsiveFlex {\n    flex-direction: column;\n    justify-content: center;\n    display: block !important;\n  }\n\n  .responsiveProductWarehouse {\n    flex-basis: 33.33%;\n  }\n\n  .responsiveProduct {\n    flex-basis: 100%;\n  }\n}\n\n.stickyCategoryBar {\n  position: fixed;\n  top: 80px;\n  left: 0;\n  width: 100%;\n  background-color: #fff; /* Adjust the background color as needed */\n  z-index: 1000; /* Adjust the z-index to make sure it appears above other elements */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollable": `products_scrollable__Z-bmY`,
	"scrollableItem": `products_scrollableItem__FasXJ`,
	"selected": `products_selected__Js7AZ`,
	"productContainer": `products_productContainer__Ut5FI`,
	"plus": `products_plus__1+u-o`,
	"counter": `products_counter__Xw085`,
	"addToCart": `products_addToCart__KpJox`,
	"productListContainer": `products_productListContainer__EodFf`,
	"sidebar": `products_sidebar__nqB1f`,
	"responsiveContainer": `products_responsiveContainer__IVYEI`,
	"responsiveSearch": `products_responsiveSearch__hfprH`,
	"responsiveFlex": `products_responsiveFlex__HltmR`,
	"responsiveFlexWarehouse": `products_responsiveFlexWarehouse__vwPPA`,
	"responsiveProduct": `products_responsiveProduct__FEskV`,
	"responsiveProductWarehouse": `products_responsiveProductWarehouse__BGy9S`,
	"responsiveModalImage": `products_responsiveModalImage__7zyYf`,
	"responsiveModalContainer": `products_responsiveModalContainer__Xtu6d`,
	"responsiveModal": `products_responsiveModal__ZaRmd`,
	"hideMobile": `products_hideMobile__VKxoq`,
	"showMobile": `products_showMobile__BchuZ`,
	"stickyCategoryBar": `products_stickyCategoryBar__VZFHb`
};
export default ___CSS_LOADER_EXPORT___;
